import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="score-slider"
export default class extends Controller {
  static targets = ["slider", "display", "hiddenField"]
  static values = {
    min: { type: Number, default: 60.001 },
    max: { type: Number, default: 99.999 },
    precision: { type: Number, default: 3 }
  }

  connect() {
    this.scaleFactor = 10 ** this.precisionValue
    this.updateDisplay()
  }

  updateDisplay() {
    const parsedRaw = parseInt(this.sliderTarget.value, 10)
    const minScaled = Math.round(this.minValue * this.scaleFactor)
    const maxScaled = Math.round(this.maxValue * this.scaleFactor)
    const rawValue = Number.isFinite(parsedRaw) ? parsedRaw : minScaled

    const clampedRaw = Math.min(maxScaled, Math.max(minScaled, rawValue))
    const actualScore = clampedRaw / this.scaleFactor
    const formattedScore = actualScore.toFixed(this.precisionValue)

    this.sliderTarget.value = clampedRaw
    this.displayTarget.textContent = formattedScore
    this.hiddenFieldTarget.value = formattedScore
  }
}
